// firebase-config.ts
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC65fWbDwNqBD_epX53j_edb3Vks8Jc6D4",
  authDomain: "pwa-pushnotification-e2c86.firebaseapp.com",
  projectId: "pwa-pushnotification-e2c86",
  storageBucket: "pwa-pushnotification-e2c86.firebasestorage.app",
  messagingSenderId: "521710985313",
  appId: "1:521710985313:web:adc753fd204852739d4a20",
  measurementId: "G-0K06YFT196"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { app, messaging };
